import React from 'react';
import Button from '@techsoftware/happay-widgets/Button';
import DialogBox from '@techsoftware/happay-widgets/DialogBox';
const ActionConfirmation = props => {
  const {
    btn2Action,
    onDialogboxClose,
    openDialogbox,
    dialogTitle,
    dialogBody,
  } = props;
  return (
    <DialogBox
      open={openDialogbox}
      id="123"
      onClose={onDialogboxClose}
      title={dialogTitle}
      titleStyle={{ fontWeight: 500 }}
      bodyStyle={{ letterSpacing: '0.25px' }}
      dialogStyle={{ justifyContent: 'flex-start', minWidth: '220px' }}
      dialogTitleContainerStyle={{ padding: "20px 30px", fontWeight: '600'  }}
      actionBorder
      crossIcon
      // height="250px"
      width="600px"
      actions={
        <div>
          <Button
            type="button"
            text="No"
            variant="secondary"
            size="medium"
            className="margin-r-20"
            onClick={onDialogboxClose}
          />
          <Button type="button" text="Yes" size="medium" onClick={btn2Action} />
        </div>
      }
    >
      <div className="padding-lr-30 padding-b-30 padding-t-10">
        {dialogBody}
      </div>
    </DialogBox>
  );
};

export default ActionConfirmation;
